<template lang="pug">
.password-input.w-input
  label.w-input__label(
    v-if="label"
    for="loginpassword"
  ) {{ label }}

  //- yeah yeah its not unique
  input.w-input__input(
    id="loginpassword"
    v-bind="$attrs"
    :type="isVisible ? 'text' : 'password'"
    :value="value"
    @input="$emit('input', $event.target.value)"
  )

  .w-input__right-block
    img.icon(
      v-if="isVisible"
      role="button"
      title="Hide password"
      :src="iconInvisible"
      @click="isVisible = false"
    )

    img.icon(
      v-else
      role="button"
      title="Show password"
      :src="iconVisible"
      @click="isVisible = true"
    )
</template>

<script>
import iconVisible from '@/assets/images/icon-visible.svg';
import iconInvisible from '@/assets/images/icon-invisible.svg';

/** Password input with 'reveal password' button */
export default {
  props: {
    label: {
      type: String,
      default: undefined,
    },

    value: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isVisible: false,
      iconVisible,
      iconInvisible,
    };
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 20px;
  height: 20px;
  opacity: 0.2;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// PasswordInput.vue?e5809428